import { css } from "@emotion/react"
import { Button, Modal, Typography } from "matsuri-ui"
import { useTranslation } from "@/hooks/useTranslation"

export const AlreadyTakenDialog = ({
    onClose,
    actionType,
    ...props
}: {
    onClose: () => void
    actionType: "approve" | "reject"
}) => {
    const { t } = useTranslation()
    return (
        <Modal
            {...props}
            body={
                <>
                    <Typography variant="h3" as="h3">
                        {t(
                            `${actionType === "approve" ? "承認" : "却下"}に失敗しました`
                        )}
                    </Typography>
                    <Typography
                        css={css`
                            margin-top: 8px;
                        `}
                    >
                        <pre>
                            {t(
                                "すでに他のユーザーによって承認されているか、作業の割り当てが解除されました。一覧画面に戻り、最新の情報を確認してください。"
                            )}
                        </pre>
                    </Typography>
                </>
            }
            footer={
                <footer
                    css={css`
                        display: flex;
                        gap: 8px;
                        justify-content: flex-end;
                    `}
                >
                    <Button variant="filled" color="primary" onClick={onClose}>
                        OK
                    </Button>
                </footer>
            }
        />
    )
}
